import { Box } from "@mui/material"
import { RslSetttingDto, SettingsTrackedDto } from "../../RslDataType"
import { isNil } from "lodash"

interface BaseSettingMultiselectDisplayProps {
    setting: RslSetttingDto,

    setSelected?: (v: Array<SettingsTrackedDto>) => void
    selected?: Array<SettingsTrackedDto>,
    

    //esthetique
    width?: number
    widthSettingName?: number
    widthName?: number
    top?: number,
    left?: number
}


const BaseSettingMultiselectDisplay = (props: BaseSettingMultiselectDisplayProps) => {

    const setSelectItem = (v: SettingsTrackedDto) => {
        if(isNil(props.setSelected))
            return;

        if(isNil(props.selected))
            props.setSelected([v])
        else if (props.selected.some(x => x.name === v.name))
            props.setSelected([...props.selected.filter(x => x.name !== v.name)])
        else
            props.setSelected([...props.selected, v])
        
    }

    return <Box display={"flex"} position={"absolute"} top={props.top} left={props.left}>
        {props.setting.states.map(s => {
            return <MultiselectOption
                setSelectedOption={setSelectItem}
                option={s}
                isSelected={props.selected?.some(x => x.name === s.name) ?? false}
            />
        })}
    </Box>
}

export default BaseSettingMultiselectDisplay


interface MultiselectOptionProps {
    option: SettingsTrackedDto,
    setSelectedOption: (v: SettingsTrackedDto) => void
    isSelected: boolean
}
const MultiselectOption = (props: MultiselectOptionProps) => {

    return <Box display={"flex"} sx={{opacity: props.isSelected ? 1 : 0.4}} marginRight={"15px"} onClick={() => props.setSelectedOption(props.option)}>
        {props.option.name}
    </Box>
}